import React, {FC} from 'react';
import CompilationsCard from "../CompilationsCard";
import './style.scss';
import CompilationsTitle from "../CompilationsTitle";
import {IMix} from "../../../constants/types";

interface ICompilationsList {
    compilations: Array<IMix>,
    fetchMixCompilation: any,
    imageUrl: string,
    title: string,
    setCurrentCompilations: any
}

const CompilationsList: FC<ICompilationsList> = ({
                                                     compilations,
                                                     fetchMixCompilation,
                                                     imageUrl,
                                                     title,
                                                     setCurrentCompilations
                                                 }) => {
    return (
        <div
            className="compilations-list"
        >
            <CompilationsTitle
                imageUrl={imageUrl}
                title={title}
            />
            <div className="compilations-list__container">
                {
                    compilations.map((item: any, index: number) => {
                        return (
                            <div className="compilations__card-wrapper" key={index}>
                                <CompilationsCard
                                    setCurrentCompilations={setCurrentCompilations}
                                    fetchMixCompilation={fetchMixCompilation}
                                    id={item.id}
                                    title={item.name}
                                    description={item.description}
                                    imageUrl={item.imageUrl}
                                />
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
};

export default CompilationsList;
